/**
 * **C02 · The forum one-pager** (Stream C, Documents.dc.html): for the parish — what came in, what
 * it cost, where the rest went — laid out by the `forum_page` engine from Money's forum P&L and
 * Volunteers' year (its people and counted hours, the families' standing). Scored against the
 * drawing by walk 99g.
 */
import type { ReactNode } from 'react';
import { forumPage } from '@cider/domain/engines';
import { useLoad, type Report } from '../views/money/shared.js';
import { usePrinted } from './printed.js';
import { DrawnPages } from './drawn-doc.js';

export function ForumOnePager({ fy }: { fy: number }): ReactNode {
  // The festival a fiscal year closes is the one held the September before its June 30.
  const festival = String(fy - 1);
  const forum = useLoad<Report>(`/money/reports/forum?fy=${String(fy)}`);
  const everyone = useLoad<{ together: { people: number; minutes: number } }>(
    `/volunteers/service-hours/${festival}/everyone?limit=1`,
  );
  const families = useLoad<{ rows: { status: string }[] }>(`/volunteers/families?year=${festival}`);
  const loads = [forum, everyone, families];
  const ready = loads.every((l) => l.data !== null || l.error !== null);
  usePrinted('doc-forum', ready, { year: fy - 1 });
  if (!ready) return <p>Reading the figures…</p>;
  const page = forumPage({
    fiscalYear: fy,
    sections: forum.data?.status === 'ok' ? forum.data.sections : null,
    together: everyone.data?.together ?? null,
    families: families.data?.rows ?? null,
  });
  return <DrawnPages pages={[page]} />;
}
